<template>
  <ConfigurationHmeTemplate
    v-if="currentOperation"
    :data="currentOperation"
    :endPointData="endPointData"
    :textData="textData"
  />
</template>
<script setup>
import { computed } from 'vue';

// Utils
import { useRoute } from 'vue-router';
import { useShaftV2 } from '@/functions/use_remote_object';
import generateTextData from '@/functions/generate_text_data';

// Components
import ConfigurationHmeTemplate from '@/components/generic/configuration_hme_template.vue';

const route = useRoute();

const currentOperation = useShaftV2({
  organisationId: route.params.organisationId,
  shaftId: route.params.shaftId,
});

const endPointData = {
  newFormRoute: 'newShaftV2Hme',
  operationType: 'heavy_mobile_equipment',
  endpointIdentifier: 'heavy_mobile_equipments',
  hmeGroupsEndpoint: `/organisations/${route.params.organisationId}/shafts_v2/shafts/${route.params.shaftId}/heavy_mobile_equipments`,
  nav: 'plants.configuration.heavy_mobile_equipment.nav',
};

const mainKey = 'shafts.configuration.heavy_mobile_equipment';
const textDataArray = [
  'search',
  'new',
];

const textData = computed(() => {
  return generateTextData(mainKey, textDataArray);
});
</script>
